import { createContext, useContext } from 'react';
import type { WorkspaceService } from './workspace-service';

export const WorkspaceServiceContext = createContext<WorkspaceService | null>(null);

export function useWorkspaceService(): WorkspaceService {
  const svc = useContext(WorkspaceServiceContext);
  if (!svc) throw new Error('useWorkspaceService must be used inside WorkspaceServiceProvider');
  return svc;
}
